import React, { Component } from 'react';

export default class ErrorPopup extends Component{
    render(){
        return(
            <div>
                <span>{this.props.message}</span><br/>
                <span>Для возможности записи свяжитесь с нами.</span><br/>
                <span>Номер телефона оператора +7 (383) 209-03-01 или напишите на почту: info@gormedosmotr.ru</span><br/><br/>
                <button className="button button-success" onClick={this.props.closeHandler} ><i className="fa fa-check"></i> На главную</button>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// frontend/src/modules/AppointmentForm/ErrorPopup.js